import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiTextField from 'features/ui/base-components/pai-text-field';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  loading: boolean;
  name: string;

  handleSearchNameChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;

  handleRenameSearch(): void;
}

const RenameContactSearchDialog: React.FC<Props> = ({ open, loading, name, handleSearchNameChange, handleClose, handleRenameSearch }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('renameSearch')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <PaiTextField value={name} label={t('name')} placeholder={t('enterSearchNamePlaceholder')} onChange={handleSearchNameChange} />
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('save')} size={'small'} border={'rounded'} loading={loading} disabled={name.trim() === ''} action={handleRenameSearch} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: 'linear-gradient(to right, #5044FF, #4AA4FF)',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '24px !important',
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default RenameContactSearchDialog;
